import React from 'react';
import { Link } from "react-router-dom";
import { Row, Col } from 'reactstrap';
const Home = () => {
  return (

    <Col xs="12" md="8" lg="8" className="py-5">
      <h1>The image rating bootcamp</h1>
      <Row>
        <Col md="12" className="py-4">
          <h4>
            Please manage your tasks from following actions.
        </h4>
        </Col>
        <Col>
          <Row>
            <Col md="12">
              <Link to="/task" className="btn btn-primary my-3">Create a task</Link>
            </Col>
            <Col>
              <Link to="/score" className="btn btn-primary my-3">Add score to task responses</Link>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}

export default Home;
